import api from ".";

interface IEmployee {
  name: string;
  active: boolean;
}

export const createNewEmployee = async (data: IEmployee) => {
  const token = localStorage.getItem("uniservice_token");

  try {
    const response = await api.post("/api/v1/employees", data, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return response;
  } catch (error) {
    console.error("Ocorreu um erro ao salvar funcionário.");
  }
};
export const updateEmployee = async (id: number, data: IEmployee) => {
  const token = localStorage.getItem("uniservice_token");
  const url = `/api/v1/employees/${id}`;
  try {
    const response = await api.put(url, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return response;
  } catch (error) {
    console.error("Ocorreu um erro ao atualizar o funcionário.");
  }
};

export const getEmployee = async () => {
  const token = localStorage.getItem("uniservice_token");
  try {
    const response = await api.get("/api/v1/employees", {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Ocorreu um erro ao carregar lista de funcionários.", error);
  }
};
